'use strict'

const IPFSRepo = require('ipfs-repo')

module.exports = (dir) => {
  const repoPath = dir || 'ipfs'
  return new IPFSRepo(repoPath)
}



//////////////////
// WEBPACK FOOTER
// ./~/ipfs/src/core/default-repo-browser.js
// module id = 532
// module chunks = 0